window.symplurTheme = {
    global: {
        useUTC: false,
    },
    lang: {
        thousandsSep: ','
    },
	colors: ["#247BA0", "#70C1B3", "#B2DBBF", "#F3FFBD", "#FF1654", "#903060", "#55BF3B", "#F09000", "#DF5353", "#7798BF", "#D8DA86"],
	credits: {
		enabled: true,
		href: 'https://www.symplur.com',
		text: 'Healthcare Social Graph® – Symplur',
        style: {
			color: '#000',
            font: '11px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
		},
		itemStyle: {
			cursor: 'pointer',
			color: '#000000',
			fontSize: '7px'
		},
		position: {
			align: 'right',
			x: 0,
			verticalAlign: 'bottom',
			y: -2
		}
	},
	chart: {
		backgroundColor: '#fff',
		borderWidth: 0,
		borderRadius: 5,
		plotBackgroundColor: null,
		plotShadow: false,
		plotBorderWidth: 0,
		spacingRight: 0,
		spacingLeft: 0
	},
	title: {
		style: {
			color: '#000',
			font: '18px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
		},
	},
	subtitle: {
		style: {
			color: '#000',
			font: '14px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
		},
	},
	xAxis: {
        type: 'datetime',
		gridLineWidth: 0,
		lineColor: '#999',
		tickColor: '#999',
		labels: {
			style: {
				color: '#000',
				font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
			},
		},
		title: {
			style: {
				color: '#000',
				font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
			},
		},
		stackLabels: {
			style: {
				color: '#000'
			}
		}
	},
	yAxis: {
		gridLineWidth: 1,
		alternateGridColor: null,
		minorTickInterval: null,
		lineColor: '#999',
		tickColor: '#999',
		lineWidth: 0,
		tickWidth: 0,
		labels: {
			style: {
				color: '#000',
				font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
			},
		},
		title: {
			style: {
				color: '#000',
				font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
			},
            text: ''
		},
		stackLabels: {
			style: {
				color: '#000'
			}
		}
	},
	legend: {
        enabled: false,
		itemStyle: {
			color: '#000',
			font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
		},
		align: 'center',
		verticalAlign: 'bottom',
		floating: false,
		borderWidth: 0,
        verticalAlign: 'bottom',
        y: 0
	},
	labels: {
		style: {
			color: '#000',
			font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
		},
	},
	tooltip: {
		style: {
			color: '#000',
			font: '12px system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
		},
	},
	plotOptions: {
		line: {
			dataLabels: {
				color: '#CCC'
			},
			marker: {
				lineColor: '#333'
			},
			series: {
				shadow: false
			},
		},
		spline: {
			marker: {
				lineColor: '#333'
			},
			series: {
				shadow: false
			},
		},
		scatter: {
			marker: {
				lineColor: '#333'
			},
			series: {
				shadow: false
			},
		},
		candlestick: {
			lineColor: 'white',
			series: {
				shadow: false
			},
		},
		column: {
			dataLabels: {
				color: 'white'
			},
			borderWidth: 0,
		},
		series: {
			pointPadding: 0,
			shadow: false,
			animation: {
    				duration: 3000,
					}
		}
	},
	toolbar: {
		itemStyle: {
			color: '#CCC'
		}
	},
	dataLabels: {
		enabled: true,
		x: 0,
		y: -20
	},
	exporting: {
		buttons: {
			exportButton: {
				borderWidth: 0,
				backgroundColor: '#fff',
				symbolFill: '#666'
			},
			printButton: {
				borderWidth: 0,
				backgroundColor: '#fff',
				symbolFill: '#666'
			}
		},
		width: 1600
	},
};
